import { render, staticRenderFns, recyclableRender, components } from "./storage-point-detail.vue?vue&type=template&id=f870f9f4&scoped=true&"
var renderjs
import script from "./storage-point-detail.vue?vue&type=script&lang=js&"
export * from "./storage-point-detail.vue?vue&type=script&lang=js&"
import style0 from "./storage-point-detail.vue?vue&type=style&index=0&id=f870f9f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f870f9f4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/storage-point-detail/storage-point-detail.vue"
export default component.exports